<template>
	<span
		:class="`
		map-marker
		map-marker-numeric
		${this.typeClass}
		${this.isImportant ? 'is-important' : ''}
		${this.isInRoute ? 'is-in-route' : ''}
		`"
		:title="object.title">
		<span class="map-marker-label">
			<span v-if="this.isInRoute">{{ this.index }}</span>
			<span v-else class="icon"><i :class="this.icon"></i></span>
		</span>
	</span>
</template>

<script>
  	import Vue from 'vue';
  	import findIndex from 'lodash/findIndex';

    const icons = {
      place:  '',
      advice: 'fas fa-exclamation'
    };

    const classes = {
      place:  '',
	  advice: 'is-advice'
	};

    export default Vue.extend({
      props:[
        'app',
        'object',
		'routeObjects'
	  ],
      watch: {
        object: {
          handler: function () {
            this.$forceUpdate();
          },
          immediate: true,
        },
        routeObjects: {
          handler: function () {
            this.$forceUpdate();
          },
          immediate: true,
        },
      },
      data () {
        return {

        }
      },
      computed: {
        icon() {
          return icons[ this.object.type ] || '';
		},
		typeClass() {
          return classes[ this.object.type ];
		},
        isInRoute() {
          return this
            .routeObjects
            .filter(routeObject => {
              return routeObject.id === this.object.id
            })
            .length === 1;
        },
		index() {
          if (this.isInRoute) {
            return findIndex(this.routeObjects, {id: this.object.id}) + 1
          }
          return null;
		},
        isImportant() {
          return (this.object.type === 'place' && this.object.is_important === true)
        }
	  },
      updated: function () {
        // this.$emit(update:objects, this.items);
      },
	  methods: {

	  }
    });
</script>